<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      validation-provider(name="correo" rules="required|email" v-slot="{ errors }")
        label Correo
        v-text-field(
          v-model="data.email"
          :disabled="disabled"
          :error-messages="errors"
          type="email"
          name="correo"
          placeholder="Ingresa tu correo electrónico, Ejemplo: juan@gmail.com"
        )
      validation-provider(name="tipo de documento" rules="required" v-slot="{ errors }")
        label Tipo de Documento (titular)
        vat-type-select(
          v-model="data.vatType"
          :error-messages="errors"
          name="tipo de documento"
        )
      validation-provider(name="numero de documento" :rules="rules.vat" v-slot="{ errors }")
        label Numero Documento (titular)
        v-text-field(
          v-model="data.vat"
          :disabled="disabled"
          :error-messages="errors"
          name="numero documento"
          type="number"
          inputmode="numeric"
          placeholder="Ingresa el número de documento"
        )
      validation-provider(name="celular" rules="required|numeric|length:9|start_with:9" v-slot="{ errors }")
        label Celular
        v-text-field(
          v-model="data.phone"
          :disabled="disabled"
          :error-messages="errors"
          mask="#-####-####"
          name="celular"
          inputmode="numeric"
          placeholder="Ingresa tu celular, así podremos contactarte para ayudarte en el proceso"
        )
      div(:class="b('toc-disclaimer')") Al "Registrarte", aceptas nuestros #[a(href="https://rebajatuscuentas.com/pe/politicas-de-privacidad" target="_blank") Términos y Condiciones y Políticas de usos de Datos.]
</template>

<script>
  import formMixin from '@/mixins/form-mixin';
  import VatTypeSelect from '@/components/inputs/vat-type-select';

  const DEFAULT_VALUES = {
    email: null,
    vatType: 1,
    vat: null,
    phone: null,
  };

  export default {
    name: 'customer-form',

    mixins: [
      formMixin(),
    ],

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },

    computed: {
      rules() {
        return {
          vat: do{
            if(this.data.vatType === 1) ({ required: true, numeric: true, length: 8 })
            else if(this.data.vatType === 2) ({ required: true, numeric: true, min: 6, max: 11 })
          },
        };
      },
    },

    components: { VatTypeSelect },
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0

    &__toc-disclaimer
      padding-top: 6px
      font-size: 14px
      font-style: italic
</style>
